// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"33055171","228":"9b2248bb","508":"f94de2a1","776":"a0235780"}[chunkId] + ".chunk.js";
};